const bounce = {
  title: "Bouncing",
  value: [
    //in
    { title: "Bounce", anim_class: "animate__bounce" },
    { title: "Bounce In Down", anim_class: "animate__bounceInDown" },
    { title: "Bounce In Left", anim_class: "animate__bounceInLeft" },
    { title: "Bounce In Right", anim_class: "animate__bounceInRight" },
    { title: "Bounce In Up", anim_class: "animate__bounceInUp" },
    //out
    { title: "Bounce Out", anim_class: "animate__bounceOut" },
    { title: "Bounce Out Down", anim_class: "animate__bounceOut" },
    { title: "Bounce Out Left", anim_class: "animate__bounceOutLeft" },
    { title: "Bounce Out Right", anim_class: "animate__bounceOutRight" },
    { title: "Bounce Out Up", anim_class: "animate__bounceOutUp" },
  ],
};

const Fade = {
  title: "Fading",
  value: [
    //in
    { title: "Fade In", anim_class: "animate__fadeIn" },
    { title: "Fade In Down", anim_class: "animate__fadeInDown" },
    { title: "Fade In Down Big", anim_class: "animate__fadeInDownBig" },
    { title: "Fade In Left", anim_class: "animate__fadeInLeft" },
    { title: "Fade In Left Big", anim_class: "animate__fadeInLeftBig" },
    { title: "Fade In Right", anim_class: "animate__fadeInRight" },
    { title: "Fade In Right Big", anim_class: "animate__fadeInRightBig" },
    { title: "Fade In Up", anim_class: "animate__fadeInUp" },
    { title: "Fade In Up Big", anim_class: "animate__fadeInUpBig" },
    //out
    { title: "Fade Out", anim_class: "animate__fadeOut" },
    { title: "Fade Out Down", anim_class: "animate__fadeOutDown" },
    { title: "Fade Out Down Big", anim_class: "animate__fadeOutDownBig" },
    { title: "Fade Out Left", anim_class: "animate__fadeOutLeft" },
    { title: "Fade Out Left Big", anim_class: "animate__fadeOutLeftBig" },
    { title: "Fade Out Right", anim_class: "animate__fadeOutRight" },
    { title: "Fade Out Right Big", anim_class: "animate__fadeOutRightBig" },
    { title: "Fade Out Up", anim_class: "animate__fadeOutUp" },
    { title: "Fade Out Up Big", anim_class: "animate__fadeOutUpBig" },
  ],
};
const Fliping = {
  title: "Fliping",
  value: [
    //in
    { title: "Flip", anim_class: "animate__flip" },
    { title: "Flip In X", anim_class: "animate__flipInX" },
    { title: "Flip In Y", anim_class: "animate__flipInY" },
    { title: "Flip Out X", anim_class: "animate__flipOutX" },
    { title: "Flip Out Y", anim_class: "animate__flipOutY" },
  ],
};
const Rotate = {
  title: "Rotating",
  value: [
    //in
    { title: "Rotate In", anim_class: "animate__rotateIn" },
    { title: "Rotate In Down Left", anim_class: "animate__rotateInDownLeft" },
    { title: "Rotate In Down Right", anim_class: "animate__rotateInDownRight" },
    { title: "Rotate In Up Left", anim_class: "animate__rotateInUpLeft" },
    { title: "Rotate In Up Right", anim_class: "animate__rotateInUpRight" },
    { title: "Rotate Out", anim_class: "animate__rotateOut" },
    { title: "Rotate Out Down Left", anim_class: "animate__rotateOutDownLeft" },
    {
      title: "Rotate Out Down Right",
      anim_class: "animate__rotateOutDownRight",
    },
    { title: "Rotate Out Up Left", anim_class: "animate__rotateOutUpLeft" },
    { title: "Rotate Out Up Right", anim_class: "animate__rotateOutUpRight" },
  ],
};
const Sliding = {
  title: "Sliding",
  value: [
    //in
    { title: "Slide In Down", anim_class: "animate__slideInDown" },
    { title: "Slide In Left", anim_class: "animate__slideInLeft" },
    { title: "Slide In Right", anim_class: "animate__slideInRight" },
    { title: "Slide In Up", anim_class: "animate__slideInUp" },

    { title: "Slide Out Down", anim_class: "animate__slideOutDown" },
    { title: "Slide Out Left", anim_class: "animate__slideOutLeft" },
    { title: "Slide Out Right", anim_class: "animate__slideOutRight" },
    { title: "Slide Out Up", anim_class: "animate__slideOutUp" },
  ],
};
const Zooming = {
  title: "Zooming",
  value: [
    //in
    { title: "Zoom In", anim_class: "animate__zoomIn" },
    { title: "Zoom In Down", anim_class: "animate__zoomInDown" },
    { title: "Zoom In Left", anim_class: "animate__zoomInLeft" },
    { title: "Zoom In Right", anim_class: "animate__zoomInRight" },
    { title: "Zoom In Up", anim_class: "animate__zoomInUp" },
    { title: "Zoom Out", anim_class: "animate__zoomOut" },
    { title: "Zoom Out Down", anim_class: "animate__zoomOutDown" },
    { title: "Zoom Out Left", anim_class: "animate__zoomOutLeft" },
    { title: "Zoom Out Right", anim_class: "animate__zoomOutRight" },
    { title: "Zoom Out Up", anim_class: "animate__zoomOutUp" },
  ],
};
const Roling = {
  title: "Rolling",
  value: [
    //in
    { title: "Roll In", anim_class: "animate__rollIn" },
    { title: "Roll Out", anim_class: "animate__rollOut" },
  ],
};
const Other = {
  title: "Othre",
  value: [
    //in
    { title: "Light Speed In Left", anim_class: "animate__lightSpeedInLeft" },
    { title: "Light Speed In Right", anim_class: "animate__lightSpeedInRight" },
    { title: "Light Speed Out Left", anim_class: "animate__lightSpeedOutLeft" },
    {
      title: "Light Speed Out Right",
      anim_class: "animate__lightSpeedOutRight",
    },

    { title: "Flash", anim_class: "animate__flash" },
    { title: "Pulse", anim_class: "animate__pulse" },
    { title: "Rubber Band", anim_class: "animate__rubberBand" },
    { title: "Shake", anim_class: "animate__shakeX" },
    { title: "Hand Shake", anim_class: "animate__headShake" },
    { title: "Swing", anim_class: "animate__swing" },
    { title: "TaDa", anim_class: "animate__tada" },
    { title: "Wobble", anim_class: "animate__wobble" },
    { title: "Jello", anim_class: "animate__jello" },
    { title: "Heart Beat", anim_class: "animate__heartBeat" },
    { title: "Hinge", anim_class: "animate__hinge" },
    { title: "Jack In The Box", anim_class: "animate__jackInTheBox" },
  ],
};

export let animations = [
  bounce,
  Fade,
  Fliping,
  Rotate,
  Sliding,
  Zooming,
  Roling,
  Other,
];
export let AnimationDelay_ = [
  { title: "One Second", anim_class: "animate__delay-1s" },
  { title: "Two Second", anim_class: "animate__delay-2s" },
  { title: "Three Second", anim_class: "animate__delay-3s" },
  { title: "Four Second", anim_class: "animate__delay-4s" },
  { title: "Five Second", anim_class: "animate__delay-5s" },
];
export let AnimationSpeed_ = [
  { title: "Faster", anim_class: "animate__faster" },
  { title: "Fast", anim_class: "animate__fast" },
  { title: "Slow", anim_class: "animate__slow" },
  { title: "Slower", anim_class: "animate__slower" },
];
